/**
 * Womit wurde zuletzt bedient — Tastatur oder Zeiger? (08.10.2026)
 *
 * Martin sah in der Seitenleiste einen blauen Rahmen um „Tiefe Fragen", obwohl
 * er den Eintrag angetippt hatte. Der Browser zeigt `:focus-visible` an einem
 * Knopf nach einem Tipp mit der Maus, sobald danach eine Taste fällt (Chromium
 * zeichnet den Rahmen dann nach) — für Martin, der beim Sprechen oft die
 * Leertaste drückt, ist das der Normalfall. Die Regel „nur per Tastatur" kann
 * CSS allein nicht sagen, darum merkt sich dieses Modul die Art der letzten
 * Bedienung als `data-eingabe` an `<html>`:
 *
 *   - `tastatur`  zuletzt TAB oder eine Pfeiltaste (wer so navigiert, braucht
 *                 den Rahmen),
 *   - `zeiger`    zuletzt ein Tipp, Klick oder Stift,
 *   - (nichts)    noch keine Bedienung: es gilt, was der Browser sagt.
 *
 * Andere Tasten (Leertaste, Enter, Buchstaben) ändern nichts — sie sagen nicht,
 * wie jemand sich bewegt. Was daraus wird, steht in style.css bei
 * „Fokusrahmen nur per Tastatur".
 *
 * Eigenes Modul, damit das VERHALTEN prüfbar ist: app.ts lässt sich im Test
 * nicht starten.
 */
export type EingabeArt = "tastatur" | "zeiger";

export function bindeFokusArt(doc: Document = document): void {
  const wurzel = doc.documentElement;
  const setze = (art: EingabeArt): void => {
    if (wurzel.dataset.eingabe !== art) wurzel.dataset.eingabe = art;
  };
  // Fangphase: auch dann, wenn ein Knopf das Ereignis anhält.
  doc.addEventListener(
    "keydown",
    (ev) => {
      if (ev.key === "Tab" || ev.key.startsWith("Arrow")) setze("tastatur");
    },
    true,
  );
  doc.addEventListener("pointerdown", () => setze("zeiger"), true);
}
